import { render } from "./ArticleGateReadinessNotice.vue?vue&type=template&id=39a0e780&scoped=true&ts=true"
import script from "./ArticleGateReadinessNotice.vue?vue&type=script&lang=ts"
export * from "./ArticleGateReadinessNotice.vue?vue&type=script&lang=ts"

import "./ArticleGateReadinessNotice.vue?vue&type=style&index=0&id=39a0e780&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a0e780"]])

export default __exports__